import { useQuery } from 'react-query';
import { queryStringFromObject } from '~/core/util/string';
import { apiGetJson } from '~/core/dapi/index';
import { DAPI_HOST } from '~/config';

export async function getLocationGeneralConfig<T>(
  config: string,
  locationId: string,
  inheritFromGroup = true
): Promise<T | undefined> {
  if (!locationId) {
    return undefined;
  }
  const qs = queryStringFromObject({
    config_names: config,
    location_id: locationId,
    inherit_from_group: inheritFromGroup,
  });
  const data = await apiGetJson<{ values: Record<string, any> }>(`${DAPI_HOST}/v1/config/?${qs}`);
  return data.data.values[config] ?? undefined;
}

export function useGeneralConfig<T>(
  config: string,
  locationId: string,
  inheritFromGroup = true,
  defaultValue: T
) {
  const { data, ...rest } = useQuery<T>(
    [`general_config`, config, locationId, inheritFromGroup],
    async () => {
      const result = await getLocationGeneralConfig<T>(config, locationId, inheritFromGroup);
      return result ?? defaultValue;
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
  return {
    data: data ?? defaultValue,
    ...rest,
  };
}
